import { apm as agent } from "@elastic/apm-rum";
import type { OttoNexus } from "../../nexus/index.js";
import type { NexusHandler } from "../../nexus/function/function.types.js";
import { isDisabled, type APMLabelsMap } from "./captureError.js";

/**
 *
 *
 */
export const isDataInvalid = <Data extends Record<string, unknown>>(data: Data): boolean =>
  !data || typeof data !== "object";

/**
 *
 *
 *
 *
 *
 *
 */
export const buildMessage = (namespace: string, data: Record<string, unknown>): string =>
  namespace.concat(
    ": ",
    Object.entries(data)
      .map(([key, value]) => `${key}: ${value}`)
      .join(", "),
  );

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function normalizeParameterInput(
  dataOrLabels: string | Error | APMLabelsMap,
  labels?: APMLabelsMap,
): {
  data: APMLabelsMap;
  message: string | Error | undefined;
} {
  if (typeof dataOrLabels === "string" || dataOrLabels instanceof Error) {
    return { data: { ...labels }, message: dataOrLabels };
  }

  const { message, ...data } = dataOrLabels;
  return { data, message: message as string | undefined };
}

/**
 *
 */
export const sendCustomError = ((
  namespace: string,
  dataOrLabels: string | Error | APMLabelsMap,
  labels?: APMLabelsMap,
) => {
  /*                */
  if (!agent) return null;

  /*                                                     */
  const { data, message } = normalizeParameterInput(dataOrLabels, labels);

  /*                                                      */
  if (isDisabled(namespace) || isDataInvalid(data)) return null;

  /*                                                                             */
  /*                                 */
  const container =
    message instanceof Error ? message : new Error(message || buildMessage(namespace, data));

  /*                                                                       */
  container.name = namespace;
  /*                                                           */
  /*                                                   */
  Object.assign(container, data);

  /*                                  */
  data.is_custom_captured = true;

  /*                                                        */
  agent.captureError(container, { labels: data });

  /*                                         */
  return container as never;
}) satisfies NexusHandler<OttoNexus["apm"]["sendCustomError"]>;
